import React from "react";
import PropTypes from "prop-types";
import NavbarWrapper from "common/components/Navbar";
import Button from "common/components/Button";
import Logo from "common/components/UIElements/Logo";
import { ButtonGroup, Container } from "./navbar.style";

import logo from "common/assets/image/interior/logo.svg";

const Navbar = ({ navbarStyle, logoStyle }) => {
  return (
    <NavbarWrapper {...navbarStyle}>
      <Container>
        <div className="logoWrapper">
          <Logo
            href="/"
            logoSrc={logo}
            title="Direct4me"
            logoStyle={logoStyle}
            style={{ marginLeft: "10px" }}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <ButtonGroup>
            <a href="mailto:info@direct4.me">
              <Button
                type="button"
                colors="primaryWithBg"
                title="CONTACT US"
                contactUsClicked
              />
            </a>
          </ButtonGroup>
        </div>
      </Container>
    </NavbarWrapper>
  );
};

Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
};

Navbar.defaultProps = {
  navbarStyle: {
    minHeight: "70px",
  },
  logoStyle: {
    width: "150px",
    height: "auto",
  },
};

export default Navbar;
